// extracted by css-extract-rspack-plugin
export default {"cls1":"WorkEvaluationCard-cls1_uYe","cls2":"WorkEvaluationCard-cls2_nSg WorkEvaluationCard-cls1_uYe"};